import React from "react";
import ActionsPopup from "../ActionsPopup";
import schema from "../ActionsPopup/foreign_worker_actions";
import cellGenerator from "./columnUtils";

const foreign_worker_columns = (isSubaccount) => [
  {
    id: "profile-name",
    Header: "Profile Name",
    accessor: "ForeignWorkerFormData.new_profile_fw_profile_name",
    Cell: (props) => cellGenerator(props),
    minWidth: 200,
    maxWidth: 250,
  },
  {
    Header: "Foreign Worker Name",
    accessor: "ForeignWorkerFormData.new_profile_fw_first",
    Cell: ({ row: { original } }) => {
      const formData = original.ForeignWorkerFormData;
      const firstName = formData.new_profile_fw_first;
      const lastName = formData.new_profile_fw_last;
      const bothNames = firstName + " " + lastName;
      return bothNames;
    },
  },
  {
    Header: "Alien Registration Number",
    accessor: "ForeignWorkerFormData.new_profile_fw_alien_reg_number",
    Cell: (props) => cellGenerator(props),
    maxWidth: 250,
  },
  {
    Header: "Date of Birth",
    accessor: "ForeignWorkerFormData.new_profile_fw_dob",
    Cell: ({ value, row: { index }, column: { id } }) => (
      <span className="cell">{value}</span>
    ),
    maxWidth: 150,
  },
  {
    Header: "Country of Birth",
    accessor: "ForeignWorkerFormData.new_profile_fw_birth_country",
    Cell: ({ value, row: { index }, column: { id } }) => (
      <span className="cell">{value}</span>
    ),
    minWidth: 260,
    maxWidth: 270,
  },
  {
    id: "actions",
    Header: "Actions",
    accessor: (d) => d,
    fixedWidth: 130,
    disableSortBy: true,
    isButton: true, // removes padding and positioning
    Cell: ({ row: { original } }) => (
      <ActionsPopup
        actionsPopupSchema={schema("foreign-worker", isSubaccount)}
        id={original.id}
      />
    ),
  },
];

export default foreign_worker_columns;
